export const DEFAULT_TITLE = "Click on a track to play it";
export const TITLE_CHIPTUNE = "Chiptune track";
export const TITLE_FIRST = "First place at a Demoparty";
export const TITLE_SECOND = "Second place at a Demoparty";
export const TITLE_THIRD = "Third place at Demoparty";
export const TITLE_BEST = "Technical track";
export const TITLE_LOVE = "Personnal favorite track"
